<div class="SLV2-levelup-popup">
    <button class="SLV2-popup-close-btn" (click)="close()">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/close-white-icon.svg" />
    </button>
    <img src="selflearnv2-ui/assets/img/self-learn-v2/upgrade-animated.gif" *ngIf="showGifIcon" class="levelup-icon" />
    <img src="selflearnv2-ui/assets/img/self-learn-v2/upgrade-static-icon.png" *ngIf="!showGifIcon" class="levelup-icon" />
    <h3 class="SLV2-popup-hdng">Level {{data.level}} unlocked!</h3>
    <h5 class="SLV2-popup-text">Mark <b>{{data.correctAnswers}} correct</b> answers to clear this level!</h5>
</div>
